import { Button, Drawer, Modal, TagPicker, SelectPicker } from "rsuite";
import bancos from "./../../data/bancos.json";
import { Icon } from "@rsuite/icons";
import { useEffect } from "react";
import "rsuite/dist/rsuite.min.css";
import Table from "../../components/Table";
import { useDispatch, useSelector } from "react-redux";
import {
  allColaboradores,
  updateColaborador,
  filterColaboradores,
  addColaborador,
  unlinkColaborador,
  allServicios,
  resetColaborador
} from "../../store/modules/colaborador/actions";


const Colaboradores = () => {
  const dispatch = useDispatch();
  const { colaboradores, behavior, form, components, colaborador, servicos } =
    useSelector((state) => state.colaborador);

  const setComponent = (component, state) => {
    dispatch(
      updateColaborador({
        components: { ...components, [component]: state },
      })
    );
  };

  const setColaborador = (key, value) => {
    console.log(value, key);
    dispatch(
      updateColaborador({
        colaborador: { ...colaborador, [key]: value },
      })
    );
  };

  const setContaBancaria = (key, value) => {
    dispatch(
      updateColaborador({
        colaborador: {
          ...colaborador,
          contaBancaria: { ...colaborador.contaBancaria, [key]: value },
        },
      })
    );
  };

  const save = () => {
    dispatch(addColaborador());
  };
  const remove = () => {
    dispatch(unlinkColaborador());
  };
  useEffect(() => {
    dispatch(allColaboradores());
    dispatch(allServicios());
   
  }, []);

  return (
    <div className="col p-5 h-100 overflow-auto">
      <Drawer
        open={components.drawer}
        size="sm"
        onClose={() => setComponent("drawer", false)}
      >
        <Drawer.Body>
          <h3>
            {behavior === "create" ? "Criar Novo" : "Atualizar"} colaborador{" "}
          </h3>

          <div className="form-group col-12 mb-3">
            <b>Email</b>
            <div className="input-group ">
              <input
                disabled={behavior === "update"}
                type="email"
                className="form-control"
                placeholder="E-mail do colaborador"
                value={colaborador.email}
                onChange={(e) => {
                  setColaborador("email", e.target.value);
                }}
              />

              {behavior === "create" && (
                <div className="input-group-append">
                  <Button
                    appearance="primary"
                    loading={form.filtering}
                    disabled={form.filtering}
                    onClick={() => dispatch(filterColaboradores())}
                  >
                    Pesquisar
                  </Button>
                </div>
              )}
            </div>
            <div className="row  mt-3">
              <div className="form-group col-6 ">
                <b className="">Nome</b>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nome do colaborador"
                  disabled={form.disabled}
                  value={colaborador.nome}
                  onChange={(e) => {
                    setColaborador("nome", e.target.value);
                  }}
                />
              </div>
              <div className="form-group col-6 ">
                <b className="">email</b>
                <input
                  type="email"
                  className="form-control"
                  placeholder="email do colaborador"
                  disabled={form.disabled}
                  value={colaborador.email}
                  onChange={(e) => {
                    setColaborador("email", e.target.value);
                  }}
                />
              </div>

              <div className="form-group col-3 ">
                <b className="">status</b>
                <select
                  type="text"
                  className="form-control"
                  placeholder="status do colaborador"
                  disabled={form.disabled && behavior === "create"}
                  value={colaborador.vinculo}
                  onChange={(e) => {
                    setColaborador("vinculo", e.target.value);
                  }}
                >
                  <option value="A">Ativo</option>
                  <option value="I">Inativo</option>
                </select>
              </div>

              <div className="form-group col-6 ">
                <b className="">Data de Nacimiento</b>
                <input
                  type="date"
                  className="form-control"
                  placeholder="Nacimento do colaborador"
                  disabled={form.disabled}
                  value={colaborador.dataNacimento}
                  onChange={(e) => {
                    setColaborador("dataNacimento", e.target.value);
                  }}
                />
              </div>
              <div className="form-group col-6 ">
                <b className="">telefone</b>
                <input
                  type="text"
                  className="form-control"
                  placeholder="telefone do colaborador"
                  disabled={form.disabled}
                  value={colaborador.telefone}
                  onChange={(e) => {
                    setColaborador("telefone", e.target.value);
                  }}
                />
              </div>

              <div className="form-group col-3 ">
                <b className="">Sexo</b>
                <select
                  type="text"
                  className="form-control"
                  placeholder="sexo do colaborador"
                  disabled={form.disabled}
                  value={colaborador.sexo}
                  onChange={(e) => {
                    setColaborador("sexo", e.target.value);
                  }}
                >
                  <option value="M">Masculino</option>
                  <option value="F">Feminino</option>
                </select>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <b>Especialidade</b>
            <TagPicker
              size="lg"
              data={servicos}
              disabled={form.disabled && behavior === "create"}
              value={colaborador.especialidades}
              onChange={(especialidade) => {
                setColaborador("especialidades", especialidade);
              }}
            />
          </div>
          <div className="row">
            <div className="form-group col-6">
              <b>Titular da Conta</b>
              <input
                type="text"
                className="form-control"
                placeholder="Nome do titular da conta"
                disabled={form.disabled}
                value={colaborador.contaBancaria.titular}
                onChange={(e) => {
                  setContaBancaria("titular", e.target.value);
                }}
              />
            </div>
            <div className="form-group col-6">
              <b>CPF / CNPJ</b>
              <input
                type="text"
                className="form-control"
                placeholder="CPF OU CNPJ"
                disabled={form.disabled}
                value={colaborador.contaBancaria.cpfCnpj}
                onChange={(e) => {
                  setContaBancaria("cpfCnpj", e.target.value);
                }}
              />
            </div>

            <SelectPicker
              disabled={form.disabled}
              value={colaborador.contaBancaria.banco}
              onChange={(banco) => {
                setContaBancaria("banco", banco);
              }}
              data={bancos}
              block
              size="lg"
            />
            <div className="form-group col-6 ">
              <b className="">Tipo da Conta</b>
              <select
                type="text"
                className="form-control"
                placeholder="status do colaborador"
                disabled={form.disabled }
                value={colaborador.contaBancaria.tipo}
                onChange={(e) => {
                  setColaborador("tipo", e.target.value);
                }}
              >
                <option value="CC">Conta Corrente</option>
                <option value="CP">Conta Poupança</option>
              </select>
            </div>

       
            <div className="form-group col-6">
              <b>Agencia da Conta</b>
              <input
                type="text"
                className="form-control"
                placeholder="Agencia da conta"
                disabled={form.disabled}
                value={colaborador.contaBancaria.agencia}
                onChange={(e) => {
                  setContaBancaria("agencia", e.target.value);
                }}
              />
            </div>
            <div className="form-group col-6">
              <b>Numero</b>
              <input
                type="text"
                className="form-control"
                placeholder="Numero da conta"
                disabled={form.disabled}
                value={colaborador.contaBancaria.numero}
                onChange={(e) => {
                  setContaBancaria("numero", e.target.value);
                }}
              />
            </div>
            <div className="form-group col-6">
              <b>Dígito</b>
              <input
                type="text"
                className="form-control"
                placeholder="DV da conta"
                disabled={form.disabled}
                value={colaborador.contaBancaria.dv}
                onChange={(e) => {
                  setContaBancaria("dv", e.target.value);
                }}
              />
            </div>
          </div>

          <Button
            block
            appearance="primary"
            className=" mt-3"
             color={behavior === "create" ? "green" : "blue"}
            size="lg"
            loading={form.saving}
            onClick={() => {          
                save();
              }
            }
          >
            {behavior === "create" ? "salvar" : "Atualizar"} colaborador
          </Button>
            {behavior === "update"&&(
              <Button
              appearance="primary"
              loading={form.saving}
              color="red"
              size="lg"
              block
              className="mt-1"
              onClick={() => {
                  setComponent("confirmDelete", true);
                }
              }
              > Remover Colaborador</Button>
            )}


        </Drawer.Body>
      </Drawer>

      <Modal
        open={components.confirmDelete}
        onHide={() => setComponent("confirmDelete", false)}
        size="xs"
      >
        <Modal.Body>
          <Icon
            icon="remind"
            style={{
              color: "#ffb300",
              fontSize: 24,
            }}
          />
          {"   "}Tem certeza que deseja excluir? Essa ação será inrreversivel!
        </Modal.Body>
        <Modal.Footer>
          <Button loading={form.saving} onClick={() => remove()} color="red">
            Sim, tenho certeza!
          </Button>
          <Button
            loading={form.saving}
            onClick={() => setComponent("confirmDelete", false)}
            appearance="subtle"
          >
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="row">
        <div className="col-6">
          <div className="w-100 d-flex justify-content-between">
            <h2 className="mb-4 mt-0">colaboradors</h2>
            <div>
              <button
                className="btn btn-primary btn-sm"
                onClick={() => {
                  dispatch(resetColaborador())
                  dispatch(
                    
                    updateColaborador({
                      behavior: "create",
                      
                    })
                  );
                  setComponent("drawer", true);
                }}
              >
                <span className="mdi mdi-plus"> Novo Colaborador</span>
              </button>
            </div>
          </div>
          <Table
            loading={form.filtering}
            data={colaboradores}
            config={[
              {
                label: "nome",
                key: "nome",
                width: 200,
                fixed: true,
              },
              {
                label: "Email",
                key: "email",
                width: 200,
              },
              {
                label: "sexo",
                key: "sexo",
                width: 200,
              },
            ]}
            actions={(colaborador) => (
              <Button appearance="primary" size="xs">
                Ver informções
              </Button>
            )}
            onRowClick={(colaborador) => {
              dispatch(
                updateColaborador({
                  behavior: "update",
                })
              );
              setComponent("drawer", true);

              dispatch(updateColaborador({ colaborador }));
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Colaboradores;
